import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'urlToLinkTitle',
  standalone: true,
})
export class UrlToLinkTitlePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value

    value = value.trim()

    if (value.startsWith('/')) {
      value = value.substring(1)
    }
    if (value.endsWith('/')) {
      value = value.substring(0, value.length - 1)
    }

    let parts = value.split('/')

    parts = parts
      .filter((part) => part.toLowerCase() !== 'admin')
      .map((part) =>
        part
          .split('-')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' '),
      )

    return parts.join(' > ')
  }
}
